import { type FilterableEditComponent, NodeType, RequiredType } from '@nodeTypeConfig/configTypes';
import { introDescriptionComponent, shortDescriptionComponent } from './descriptionComponent';
import { proThumbnailComponent } from './proThumbnailComponent';
import { titleComponent } from './titleComponent';

export const proTileStandardComponents: Array<FilterableEditComponent> = [
  titleComponent,
  {
    ...shortDescriptionComponent,
    maxLength: 80,
    required: RequiredType.WARNING,
    showInAncestorTypes: [NodeType.PRO_THEME_HOME_FULL, NodeType.PRO_THEME_HOME_TEXT],
  },
  introDescriptionComponent,
  {
    ...proThumbnailComponent,
    label: 'Tegelfoto',
    width: 6,
    showInAncestorTypes: [NodeType.PRO_THEME_HOME_FULL, NodeType.PRO_THEME_HOME_PICTURE],
    hideInAncestorTypes: [NodeType.PRO_THEME_HOME_TEXT],
  },
];
